<p-dialog [(visible)]="isVisible"
          [modal]="true"
          [closable]="false"
          appendTo="body"
          [style]="{ width: '25rem' }"
>
  <div class="flex flex-column">
    <div class="text-lg-semibold text-gray-900">{{ title() }}</div>
    <div class="mt-1 text-sm-regular text-gray-600">{{ message() }}</div>
  </div>
  <ng-template #header>
    <div class="flex align-items-center justify-content-between w-full">
      <div class="flex justify-content-center align-items-center dialog-header-icon">
        <app-slash-circle-01 stroke="#414651" width="20px" height="20px"></app-slash-circle-01>
      </div>
      <app-x-close stroke="#ADB0B8" width="12" height="12" class="cursor-pointer" (click)="cancelled.emit()"></app-x-close>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="flex justify-content-end align-items-center w-full">
      <app-button [btnSeverity]="ButtonSeverity.SECONDARY" [btnSize]="ButtonSize.MD" (btnClicked)="cancelled.emit()">
        <div class="text-sm-semibold text-gray-900">Odustani</div>
      </app-button>
      <app-button class="ml-2-5" [isDestructive]="true" [btnSeverity]="ButtonSeverity.PRIMARY" [btnSize]="ButtonSize.MD" (btnClicked)="confirmed.emit()">
        <div class="text-sm-semibold text-white">{{ confirmLabel() }}</div>
      </app-button>
    </div>
  </ng-template>
</p-dialog>
